import { Asset, Token } from "~/modules/assets/types";
import { Networks } from "~/schema";

// // // //

/** Returns every Solana token on an asset that carries an on-chain mint. */
export function getSolanaTradableTokens(asset: Asset): Token[] {
    return asset.tokens.filter(
        (token) => token.network?.slug === Networks.solana && !!token.address,
    );
}

/**
 * Returns the first Solana mint for callers that need a single default token.
 */
export function getSolanaTradableToken(asset: Asset): Token | undefined {
    return getSolanaTradableTokens(asset)[0];
}

/**
 * filterTradableAssets
 * Narrows a list of assets to those with a swappable Solana mint. Applied
 * server-side in getStaticProps since "has a Solana token with an on-chain
 * address" is not an API-level filter.
 */
export function filterTradableAssets(assets: Asset[]): Asset[] {
    return assets.filter(
        (asset) => getSolanaTradableToken(asset) !== undefined,
    );
}
